import { FC } from "react";
import { useLocation } from "react-router-dom";
import { Box, Link, Stack, Typography } from "@mui/material";
import { PanelLayout } from "../PanelLayout";
import { useLinkedVerificationRequests } from "../../hooks/useLinkedVerificationRequests";
import { ICompanyVerificationStatusesConfig } from "../../network";
import { linkLabel } from "../../utils/linkLabel";
import { VerificationStatusBadge } from "../VerificationStatusBadge";

export const LinkedVRsPanel: FC<{
  verificationRequestId?: string;
  statusesConfig: ICompanyVerificationStatusesConfig;
}> = ({ verificationRequestId, statusesConfig }) => {
  const location = useLocation();
  const [links, isLoading] = useLinkedVerificationRequests(verificationRequestId);

  if (isLoading || links.length === 0) {
    return null;
  }

  return (
    <PanelLayout title='Links'>
      <Stack marginTop='16px' spacing={1.5}>
        {links.map((link) => {
          const linkLabelText = linkLabel(link.linkType);

          return (
            <Link
              key={`${link.verificationRequestId}-${link.linkType}`}
              href={`/verification-requests/${link.verificationRequestId}${location.search}`}
              underline='none'
              color='inherit'
            >
              <Box
                sx={{
                  border: "1px solid #E6E8EB",
                  borderRadius: "8px",
                  padding: "10px 12px",
                }}
              >
                <Stack
                  direction='row'
                  alignItems='center'
                  justifyContent='space-between'
                  spacing={1}
                >
                  <Box>
                    <Typography sx={{ fontWeight: 700, fontSize: "14px" }}>
                      {linkLabelText}
                    </Typography>
                    <Typography sx={{ fontSize: "14px", color: "#6D7580" }}>
                      {link.name || `ID: ${link.verificationRequestId}`}
                    </Typography>
                  </Box>

                  <VerificationStatusBadge
                    status={link.status}
                    statusesConfig={statusesConfig}
                    size="small"
                  />
                </Stack>
              </Box>
            </Link>
          );
        })}
      </Stack>
    </PanelLayout>
  );
};
